import "core-js/modules/es.array.push.js";
import { createNamespacedHelpers } from "vuex";
const walletVuex = createNamespacedHelpers("wallet");
export default {
  name: "popHowWorks",
  props: {
    show: null
  },
  computed: {
    ...walletVuex.mapState(["isMobile"])
  },
  methods: {
    onClose() {
      this.$emit("update:show", false);
    },
    onSkip() {
      this.onClose();
      setTimeout(() => {
        this.$router.push("/launch");
      }, 200);
    }
  }
};